import { useErrorsBus } from '@/core/composables/useErrorsBus'

// const DEBUG = import.meta.env.DEV

export function install(app) {
  const { errorsBus } = useErrorsBus()

  app.config.errorHandler = (err, vm, info) => {
    const componentName = vm?.$?.type?.__name || vm?.$?.parent?.type?.__name || 'UnknownComponent'
    const message = `[${componentName}]: ${err} (${info})`
    console.error(message)

    errorsBus.emit()
  }
}
